import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, VoiceRecording } from "@/types";

export const voiceRecordingsQueryKey = (userId?: number) =>
  ["voice-recordings", userId ?? "all"] as const;

export function useGetVoiceRecordings({ userId }: { userId?: number } = {}) {
  return useQuery({
    queryKey: voiceRecordingsQueryKey(userId),
    queryFn: async () => {
      const path = userId
        ? `voice-recordings?userId=${userId.toString()}`
        : "voice-recordings";
      const res = await guacHttpClient.get<
        VoiceRecording[],
        HttpResponse<VoiceRecording[]>
      >(path);
      return res.data;
    },
    // Signed URLs live an hour; refetching on focus keeps them playable.
    staleTime: 5 * 60 * 1000,
  });
}
